import Image from "next/image";
import type { PropsWithChildren } from "react";
import styles from "./YarnWidget.module.css";

export const YarnWidget = ({ children }: PropsWithChildren) => {
	return <div className={styles.spread}>{children}</div>;
};

export const Colors = ({ total, swatchUrl }: { total: number; swatchUrl?: string }) => {
	return (
		<div className={styles.circles}>
			<div className={styles.imageWrapper}>
				{swatchUrl && (
					<Image
						loading="lazy"
						alt="farge"
						width={12}
						height={12}
						src={swatchUrl}
						className={styles.circleImage}
					/>
				)}
			</div>
			{!!total && total > 1 && <strong>{`+${total - 1}`}</strong>}
		</div>
	);
};

export const WeightAndLength = ({ children }: PropsWithChildren) => {
	return <p className={styles.weightAndLength}>{children}</p>;
};
